
import axios from 'axios';
import { getAPIUrl } from '../../../Constants.ts';
import { RoleGroup, RoleGroupRequest, RoleGroupRequestParam } from './_model';

const API_URL = getAPIUrl();

const GET_ROLE_GROUPS = `${API_URL}/values/GetRoleGroupEx`;
const UPSERT_ROLE_GROUPS = `${API_URL}/values/UpsertRoleGroups`;


export function GetRoleGroups(request: RoleGroupRequestParam) {
    return axios.post<RoleGroup[]>(GET_ROLE_GROUPS, request);
}

export function UpsertRoleGroup(request: RoleGroupRequest) {
    return axios.post<string>(UPSERT_ROLE_GROUPS, request);
}
